module.exports = __webpack_public_path__ + "media/svg/rs-4bf971be.svg";